import { Component, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { VerInformesComponent } from '../../../forms/informes/ver-informes/ver-informes.component';
import { InformePersonalizadoService } from '../../../providers/informe-personalizado.service';
@Component({
  selector: 'app-informes-personalizados',
  templateUrl: './informes-personalizados.component.html',
  styleUrls: ['./informes-personalizados.component.scss']
})
export class InformesPersonalizadosComponent {
  @ViewChild('verInformes') verInformes: VerInformesComponent;
  public oferta: string;
  public tipoOferta: string;
  lista:any;
  constructor(
    private router: Router,
    private InformePersonalizadoService: InformePersonalizadoService,

  ) { }

  ngOnInit() {
   
  }

  actualizarTabla(): void {
    this.verInformes.actualizarTabla();
  }
}
